/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Aniket Singh",
  title: "Hi all, I'm Aniket",
  subTitle: emoji(
    "A versatile full-stack developer 🚀 with experience delivering robust, user-focused software across diverse systems and technology stacks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ZJX7OqmiW4vF8HDmnk9RJpb_CsLsyo41/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/aniketsingh98571",
  linkedin: "https://www.linkedin.com/in/aniketsingh98571/",
  gmail: "aniketsingh.career@gmail.com",
  medium: "https://medium.com/@aniket98571",
  dev: "https://dev.to/aniketsingh98571", // Add your dev.to profile URL
  youtube: "https://www.youtube.com/@techtrends688", // Add your YouTube channel URL
  topmate: "https://topmate.io/aniketsingh98571/", // Add your Topmate profile URL
  producthunt: "https://www.producthunt.com/@aniketsingh98571", // Add your Product Hunt profile URL
  instagram: "https://www.instagram.com/curious_coder98/", // Add your Instagram profile URL
  twitter: "https://x.com/Techno_Dict", // Add your Twitter/X profile URL
  substack: "https://aoristosaporos.substack.com/", // Add your Substack newsletter URL
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web  applications"
    ),
    emoji(
      "⚡ Develop robust and scalable Back-end / Server-side applications for your web services"
    ),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Netlify"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: {
    frontend: [
      {
        skillName: "html-5",
        fontAwesomeClassname: "fab fa-html5"
      },
      {
        skillName: "css3",
        fontAwesomeClassname: "fab fa-css3-alt"
      },
      {
        skillName: "JavaScript",
        fontAwesomeClassname: "fab fa-js"
      },
      {
        skillName: "reactjs",
        fontAwesomeClassname: "fab fa-react"
      },
      {
        skillName: "nextjs",
        fontAwesomeClassname: "fab fa-react"
      },
      {
        skillName: "tailwind css",
        fontAwesomeClassname: "fab fa-css3-alt"
      },
      {
        skillName: "antd design system",
        fontAwesomeClassname: "fab fa-figma"
      },
      {
        skillName: "MUI",
        fontAwesomeClassname: "fab fa-react"
      },
      {
        skillName: "shadcn",
        fontAwesomeClassname: "fas fa-cube"
      }
    ],
    backend: [
      {
        skillName: "nodejs",
        fontAwesomeClassname: "fab fa-node"
      },
      {
        skillName: "npm",
        fontAwesomeClassname: "fab fa-npm"
      },
      {
        skillName: "sql-database",
        fontAwesomeClassname: "fas fa-database"
      },
      {
        skillName: "nosql-database",
        fontAwesomeClassname: "fas fa-database"
      },
      {
        skillName: "python",
        fontAwesomeClassname: "fab fa-python"
      }
    ],
    cloud: [
      {
        skillName: "aws",
        fontAwesomeClassname: "fab fa-aws"
      },
      {
        skillName: "firebase",
        fontAwesomeClassname: "fas fa-fire"
      },
      {
        skillName: "vercel",
        fontAwesomeClassname: "fas fa-cloud"
      },
      {
        skillName: "netlify",
        fontAwesomeClassname: "fas fa-cloud"
      },
      {
        skillName: "github",
        fontAwesomeClassname: "fab fa-github"
      }
    ],
    ai: [
      {
        skillName: "LLM's",
        fontAwesomeClassname: "fas fa-brain"
      },
      {
        skillName: "agents",
        fontAwesomeClassname: "fas fa-robot"
      },
      {
        skillName: "MCP",
        fontAwesomeClassname: "fas fa-plug"
      },
      {
        skillName: "orchestration",
        fontAwesomeClassname: "fas fa-sitemap"
      }
    ]
  },
  display: true // Set false to hide this section, defaults to true
};

// Services Section

const servicesSection = {
  title: "Services",
  subtitle: "WHAT I OFFER",
  services: [
    {
      title: emoji("Frontend 💻"),
      icon: "💻",
      description: [
        "Develop highly interactive and responsive user interfaces using modern frameworks like React, Next.js, and Vue.js.",
        "Create pixel-perfect designs with CSS3, Tailwind CSS, and Material-UI, ensuring seamless user experiences across all devices.",
        "Build performant single-page applications (SPAs) with optimized rendering and state management.",
        "Implement accessibility standards and best practices to ensure inclusive web experiences for all users.",
        "Integrate third-party APIs and services to enhance functionality and user engagement."
      ]
    },
    {
      title: emoji("Backend ⚙️"),
      icon: "⚙️",
      description: [
        "Design and develop robust server-side applications using Node.js, Python, and modern backend frameworks.",
        "Build RESTful and GraphQL APIs with proper authentication, authorization, and security measures.",
        "Implement scalable database solutions using both SQL (PostgreSQL, MySQL) and NoSQL (MongoDB) databases.",
        "Create microservices architectures and integrate with cloud services for enhanced scalability and reliability.",
        "Optimize application performance through caching strategies, database indexing, and efficient query design."
      ]
    },
    {
      title: emoji("Cloud ☁️"),
      icon: "☁️",
      description: [
        "Deploy and manage applications on cloud platforms like AWS, Firebase, Vercel, and Netlify.",
        "Implement CI/CD pipelines for automated testing, building, and deployment processes.",
        "Configure cloud infrastructure including serverless functions, containerization, and auto-scaling solutions.",
        "Set up monitoring, logging, and observability tools to ensure optimal application performance and reliability.",
        "Optimize cloud costs while maintaining high availability and performance standards."
      ]
    },
    {
      title: emoji("Design 🎨"),
      icon: "🎨",
      description: [
        "Create intuitive and user-friendly interface designs that prioritize user experience and accessibility.",
        "Develop responsive layouts that work seamlessly across desktop, tablet, and mobile devices.",
        "Design consistent design systems using modern UI libraries like Ant Design, Material-UI, and Shadcn.",
        "Implement design principles including typography, color theory, and visual hierarchy for engaging interfaces.",
        "Collaborate with stakeholders to translate business requirements into functional and aesthetically pleasing designs."
      ]
    },
    {
      title: emoji("AI 🤖"),
      icon: "🤖",
      description: [
        "Design and deploy intelligent AI agents tailored to specific workflows, business logic, and operational needs.",
        "Build scalable orchestration layers that manage multi-agent collaboration, task routing, and execution control.",
        "Integrate and abstract multiple LLM providers to optimize performance, cost, and reasoning depth per use case.",
        "Develop custom Model Context Protocol (MCP) servers to securely connect AI systems with internal tools and data sources."
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Sandip Institute of Technology and Research Center",
      logo: require("./assets/images/sitrc.jpg"),
      subHeader: "Bachelor of Engineering in Computer Engineering",
      duration: "July 2018 - July 2022",
      desc: "Two review papers titled `Semantic Technologies` and `Indian Education System` have been published by our team."
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "100%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "100%"
    },
    {
      Stack: "Database",
      progressPercentage: "100%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Last9",
      companylogo: require("./assets/images/last9_logo.jpeg"),
      date: "June 2026 - Present",
      desc: "Observability for AI Native Teams!",
      descBullets: []
    },
    {
      role: "SDE2",
      company: "Procedure",
      companylogo: require("./assets/images/procedure_logo.jpg"),
      date: "June 2024 - June 2026",
      desc: "Engaged in delivering comprehensive full-stack solutions to clients.",
      descBullets: []
    },
    {
      role: "Software Engineer",
      company: "WebOasis",
      companylogo: require("./assets/images/weboasis.png"),
      date: "July 2022 – June 2024",
      desc: "Engaged in delivering comprehensive full-stack web2 and web3 solutions to clients.",
      descBullets: []
    },
    {
      role: "Frontend Intern",
      company: "WebOasis",
      companylogo: require("./assets/images/weboasis.png"),
      date: "March 2022 – May 2022",
      desc: "Engaged in delivering comprehensive frontend solutions to clients.",
      descBullets: []
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Open Source Projects Section (npm packages, libraries, etc.)

const openSourceProjectsSection = {
  title: "Open Source",
  subtitle: "Libraries and tools I've published",
  projects: [
    {
      title: "number-fmt",
      description:
        "TypeScript library for converting numbers between Indian and International number formatting. Useful for financial apps, e-commerce, or any app serving users across regions.",
      link: "https://www.npmjs.com/package/number-fmt"
    },
    {
      title: "tailwind-randomizer",
      description:
        "Webpack + PostCSS plugin for obfuscating Tailwind CSS class names. Helps protect your utility class names for security.",
      link: "https://www.npmjs.com/package/tailwind-randomizer"
    }
  ],
  display: true // Set false to hide this section
};

// Project Domains Section

const projectDomainsSection = {
  title: "Project Domains",
  subtitle: "Diverse domains I have worked on",
  domains: [
    {
      name: "Business Portfolio management platform",
      icon: emoji("📊")
    },
    {
      name: "Observability platforms",
      icon: emoji("📈")
    },
    {
      name: "Ticket booking applications",
      icon: emoji("🎫")
    },
    {
      name: "NFT Platforms",
      icon: emoji("🖼️")
    },
    {
      name: "Online real estate portal",
      icon: emoji("🏠")
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Hobbies Section

const hobbiesSection = {
  title: emoji("Hobbies & Interests 🎯"),
  subtitle: "What I like the most",
  hobbies: [
    {
      name: "Trekking",
      icon: emoji("⛰️")
    },
    {
      name: "Music",
      icon: emoji("🎵")
    },
    {
      name: "Badminton and Cricket",
      icon: emoji("🏸")
    },
    {
      name: "Gym",
      icon: emoji("💪")
    },
    {
      name: "Exploring nature and beautiful cafe's",
      icon: emoji("☕")
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Communities",
  subtitle:
    "Some groups were spearheaded by me during my undergraduate studies. ",
  projects: [
    {
      image: require("./assets/images/google_developers.png"),
      projectName: "Google Developer Students Club",
      projectDesc:
        "Google Developer Student Club Leads are passionate leaders at their university who are dedicated to helping their peers learn and connect. We are the leaders who believe in building and growing the community. Our role is to guide and provide proper resources to peers so that they can flourish in their respective fields. We also build solutions to solve real worlds problems."
    },
    {
      image: require("./assets/images/scaler.jpeg"),
      projectName: "Scaler",
      projectDesc:
        "The student club of India's first online tech academy. Scaler Achievers learn lifelong transferable skills, develop as future leaders, and help their peers in college gain high-quality technical skills. Scaler Achievers are the face of Scaler Academy at their college campuses and will help their peers get access to the best tech education at India's first online tech academy"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Smart India Hackathon",
      subtitle: "Qualified for regionals",
      image: require("./assets/images/sih.png"),
      imageAlt: "SIH Logo",
      footerLink: [
        {
          name: "Official Site",
          url: "https://www.sih.gov.in/"
        }
      ]
    },
    {
      title: "Mumbai Hacks 2025",
      subtitle: "Finalists",
      image: require("./assets/images/mumbaiHacks.png"),
      imageAlt: "Mumbai Hacks Logo",
      footerLink: [
        {
          name: "Official Site",
          url: "https://mumbaihacks.com/"
        }
      ]
    },
    {
      title: "IEEE Post covid rehabilitation hackathon",
      subtitle: "Third Place",
      image: require("./assets/images/ieee_hackathon.jpg"),
      imageAlt: "IEEE Hackathon Logo",
      footerLink: [
        {
          name: "View Post",
          url: "https://www.facebook.com/ieeebombay/photos/a.2950211688441562/3349092948553432/?type=3"
        }
      ]
    },
    {
      title: "The Complete JavaScript Course 2024: From Zero to Expert!",
      subtitle:
        "Master JavaScript in 2024: A Comprehensive Guide for Beginners to Become Professionals!",
      image: require("./assets/images/udemy.png"),
      imageAlt: "Udemy Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.udemy.com/certificate/UC-0ef67a58-46f0-4b22-8f3e-0246158ed5ea/"
        }
      ]
    },
    {
      title: "Git & Github Master Course(2022)",
      subtitle:
        "Become a Pro in Version Control: Comprehensive Guide to Git & Github (2022).",
      image: require("./assets/images/udemy.png"),
      imageAlt: "Udemy Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.udemy.com/certificate/UC-662d40ad-8cab-4c2f-95c8-a3d74bfe1f4e/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://procedure.tech/blogs/ai-agents-how-they-work-use-cases",
      title:
        "The Rise of AI Agents: How Modern Systems Observe, Decide, and Act",
      description:
        "AI agents have quietly transitioned from experiments to real-world production systems. They are now being used to review code, automate workflows, monitor systems, and execute multi-step tasks across teams."
    },
    {
      url: "https://procedure.tech/blogs/observability-101-logs-metrics-traces-monitoring-modern-systems",
      title:
        "Observability 101: Logs, Metrics, Traces & Monitoring Modern Systems",
      description:
        "Understand observability from first principles: traces, logs, metrics, alerts, dashboards, OpenTelemetry, and how tools like Grafana or Datadog fit into real workflows."
    },
    {
      url: "https://procedure.tech/blogs/blog-scalable-frontend-architecture-guide",
      title:
        "Scalable Frontend Architecture: A Step-by-Step Guide for Modern Web Apps",
      description:
        "Learn how to design and implement a scalable frontend architecture for modern web applications. This guide covers topics like component-based architecture, state management, data fetching, and performance optimization."
    },
    {
      url: "https://procedure.tech/blogs/role-based-access-control-rbac-guide",
      title:
        "Role-Based Access Control (RBAC) Explained: Your Guide to Secure, Scalable Access Management",
      description:
        "Role-based access control (RBAC) is a powerful way to manage user permissions and access to resources. It allows you to define roles and assign permissions to them, rather than granting permissions directly to users."
    },
    {
      url: "https://procedure.tech/blogs/user-experience-observability-metrics-errors-and-tools-you-need-to-know",
      title:
        "User Experience Observability: Metrics, Errors, and Tools You Need to Know",
      description:
        "Understand how to observe what users actually experience—not just server uptime. Learn about real user monitoring (RUM), performance metrics like LCP & CLS, session tracking, and tools like OpenTelemetry, ClickHouse, and Datadog to build user-first observability systems"
    },
    {
      url: "https://procedure.tech/blogs/beginner-s-guide-to-model-context-protocol-(mcp)-for-smarter-ai-systems",
      title:
        "Beginner’s Guide to Model Context Protocol (MCP) for Smarter AI Systems",
      description:
        "Explore the basics of Model Context Protocol and how it enhances AI agents with memory, context handling, and real use cases."
    },
    {
      url: "https://dev.to/aniketsingh98571/mobile-web-woes-navigating-common-css-and-font-issues-1m99",
      title: "Mobile Web Woes: Navigating Common CSS and Font Issues 📱🔧",
      description:
        "Explore the common challenges in mobile web development, specifically focusing on CSS and font issues. This guide provides practical solutions to navigate these problems, ensuring a seamless user experience across all mobile devices."
    },
    {
      url: "https://dev.to/aniketsingh98571/things-to-follow-things-to-avoid-in-css-nj9",
      title: "Things to follow, Things to avoid in CSS!",
      description:
        "Discover the best practices and common pitfalls in CSS. This guide provides valuable insights on what to embrace and what to steer clear of for effective CSS coding."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// AI Hacking Section — Experimenting with AI tools, stacks & frameworks (YouTube videos in 2x2 grid)
const aiHackingSection = {
  title: "AI Hacking",
  subtitle:
    "Experimenting and testing different AI tools, stacks, and frameworks — hands-on explorations and demos.",
  videos: [
    {
      embedUrl: "https://www.youtube.com/embed/cKEVFsn2V9s",
      title: "AI Hacking Video 1"
    },
    {
      embedUrl: "https://www.youtube.com/embed/5IcV_RzAKes?start=16",
      title: "AI Hacking Video 2"
    }
  ],
  display: true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-0000000000",
  email_address: "saadpasta70@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "Techno_Dict", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  servicesSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  openSourceProjectsSection,
  projectDomainsSection,
  hobbiesSection,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  aiHackingSection,
  contactInfo,
  twitterDetails,
  isHireable
};
